export enum AIHelperAction {
    TONE = 'TONE',
    IMPROVE = 'IMPROVE',
    SPELLING = 'SPELLING',
    // LENGTH = 'LENGTH'
}

export enum AIHelperToneOption {
    FORMAL = 'FORMAL',
    PROFESSIONAL = 'PROFESSIONAL',
    NEUTRAL = 'NEUTRAL',
    POLITE = 'POLITE',
    APPRECIATIVE = 'APPRECIATIVE'
}

export enum AIHelperLengthOption {
    SHORTER = ' SHORTER',
    LONGER = 'LONGER'
}
